import { serialize } from 'utils/utils';
import LHX from 'utils/LHX';
import { CALL_API, Schemas } from '../middleware/api';

export const TYPES = {
  ANNUAL_AVAILABILITY_REQUEST: 'ANNUAL_AVAILABILITY_REQUEST',
  ANNUAL_AVAILABILITY_SUCCESS: 'ANNUAL_AVAILABILITY_SUCCESS',
  ANNUAL_AVAILABILITY_FAILURE: 'ANNUAL_AVAILABILITY_FAILURE',
  ANNUAL_AVAILABILITY_HO_REQUEST: 'ANNUAL_AVAILABILITY_HO_REQUEST',
  ANNUAL_AVAILABILITY_HO_SUCCESS: 'ANNUAL_AVAILABILITY_HO_SUCCESS',
  ANNUAL_AVAILABILITY_HO_FAILURE: 'ANNUAL_AVAILABILITY_HO_FAILURE',
  SET_LOADING_STATUS: 'SET_LOADING_STATUS',
  CHANGE_NUMBER_OF_NIGHTS: 'CHANGE_NUMBER_OF_NIGHTS',
  CHANGE_CALDATE_VALUE: 'CHANGE_CALDATE_VALUE',
  SET_DIMENSION_PROPERTY: 'SET_DIMENSION_PROPERTY',
};

export const loadAnnualAvailability = (params) => {
  const defaultParams = {
    url: 'MANDATORY-TO-BE-OVERRIDEN',
    state: '',
    flex: '',
    geoip: LHX.isEnabled('isGeolocationEnabled') ? 1 : '',
    groupPricing: 0,
  };

  const mergedParams = Object.assign(defaultParams, params);

  if (!mergedParams.state) {
    mergedParams.state = '';
  }

  const isHotelOnly = params.view === 'HO';

  const types = isHotelOnly ? [
    TYPES.ANNUAL_AVAILABILITY_HO_REQUEST,
    TYPES.ANNUAL_AVAILABILITY_HO_SUCCESS,
    TYPES.ANNUAL_AVAILABILITY_HO_FAILURE,
  ] : [
    TYPES.ANNUAL_AVAILABILITY_REQUEST,
    TYPES.ANNUAL_AVAILABILITY_SUCCESS,
    TYPES.ANNUAL_AVAILABILITY_FAILURE,
  ];

  return {
    [CALL_API]: {
      types,
      schema: Schemas.ANNUAL_AVAILABILITY,
      endpoint: `/api/annual-availability.json?${serialize(mergedParams)}`,
    },
  };
};

export const startLoading = () => ({
  type: TYPES.SET_LOADING_STATUS,
});

export const changeNumberOfNights = (addDimId, removeDimId) => ({
  type: TYPES.CHANGE_NUMBER_OF_NIGHTS,
  addDimId,
  removeDimId,
});

export const changeDimEntKeyVal = (dimId, key, value) => ({
  type: TYPES.SET_DIMENSION_PROPERTY,
  dimId,
  key,
  value,
});

export const changeCalDateValue = calDate => ({
  type: TYPES.CHANGE_CALDATE_VALUE,
  calDate,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/annualAvailabilityActions.js
 **/